import _Promise from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/core-js/promise";
import _Array$from from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/core-js/array/from";
import _Object$assign from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/core-js/object/assign";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name";
import _objectSpread from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters, mapActions } from 'vuex';
import { url } from '@tencent/vft-common';
import SharePop from '../components/SharePop';
import service from '../services/service';
export default {
  name: 'invite-button',
  components: {
    SharePop: SharePop
  },
  props: ['text'],
  data: function data() {
    return {
      shareButtonText: this.text || '',
      fetch: false,
      headUrl: '',
      shortUrl: '',
      bgImgLoaded: false,
      eggBase: ['//puep.qpic.cn/vupload/0/20190116_1547629917113_fqer0kb9u8.png/0', '//puep.qpic.cn/vupload/0/20190116_1547629917113_fqer0kb9u8.png/0', '//puep.qpic.cn/vupload/0/20190116_1547629917113_fqer0kb9u8.png/0', '//puep.qpic.cn/vupload/0/20190116_1547629917113_fqer0kb9u8.png/0']
    };
  },
  computed: _objectSpread({}, mapState(['isLogin']), mapGetters(['myShareCode', 'eggInfo', 'userInfo', 'pangdanShareConfig', 'shareConfig', 'egg', 'payVip', 'shareLogo']), {
    avatar: function avatar() {
      if (this.userInfo) {
        return this.userInfo.headurl;
      } else {
        return '//vm.gtimg.cn/tencentvideo/vstyle/newvip/style/h5/imgs/common/head_default.svg';
      }
    },
    userType: function userType() {
      return this.userInfo && this.userInfo.type || 0;
    },
    nick: function nick() {
      return this.userInfo && this.userInfo.nick || '';
    },
    eggImg: function eggImg() {
      return this.egg && this.egg.image;
    },
    dan: function dan() {
      return this.egg && this.egg.name;
    },
    lvIcon: function lvIcon() {
      if (!this.payVip) {
        return '';
      }

      if (!this.payVip.vip) {
        return '';
      }

      switch (this.payVip.level) {
        case 7:
          return '//puep.qpic.cn/vupload/0/20190115_1547623719609_imsalw9f5z.png/0';

        case 6:
          return '//puep.qpic.cn/vupload/0/20190115_1547623719609_wencg0wb04f.png/0';

        case 5:
          return '//puep.qpic.cn/vupload/0/20190115_1547623719608_vyjv390lpf.png/0';

        case 4:
          return '//puep.qpic.cn/vupload/0/20190115_1547623719608_ljry3o3nn8.png/0';

        case 3:
          return '//puep.qpic.cn/vupload/0/20190115_1547623719608_07hyx3g6rmhb.png/0';

        case 2:
          return '//puep.qpic.cn/vupload/0/20190115_1547623719607_8bm8giwg6r5.png/0';

        case 1:
          return '//puep.qpic.cn/vupload/0/20190115_1547623719607_yan7qifxfuh.png/0';

        default:
          return '';
      }
    }
  }),
  watch: {
    avatar: {
      immediate: true,
      handler: function () {
        var _handler = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(v) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!v) {
                    _context.next = 4;
                    break;
                  }

                  _context.next = 3;
                  return this.img2base64(url.buildUrl(v, {
                    _: new Date().getTime()
                  }), 'anonymous');

                case 3:
                  this.headUrl = _context.sent;

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function handler(_x) {
          return _handler.apply(this, arguments);
        }

        return handler;
      }()
    }
  },
  methods: {
    shareHandler: function () {
      var _shareHandler = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var url, suRes;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.isLogin) {
                  _context2.next = 3;
                  break;
                }

                this._openLogin();

                return _context2.abrupt("return", false);

              case 3:
                if (!(this.eggInfo['egg_count'] <= 0)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", false);

              case 5:
                url = "https://film.qq.com/weixin/v3/d2d-cny/index.html?shareCode=".concat(this.myShareCode);
                _context2.prev = 6;
                _context2.next = 9;
                return service.shortUrl("".concat(url, "&ptag=luckyeggshare2"));

              case 9:
                suRes = _context2.sent;

                if (suRes.ret === 0) {
                  this.shortUrl = suRes['short_url'];
                } else {
                  this.shortUrl = "".concat(url, "&ptag=luckyeggshare2");
                }

                _context2.next = 17;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](6);
                console.error(_context2.t0);
                this.shortUrl = "".concat(url, "&ptag=luckyeggshare2");

              case 17:
                this.share.setShare(_Object$assign({}, this.pangdanShareConfig, {
                  link: "".concat(url, "&ptag=luckyeggshare")
                }));
                this.$refs.sharePop.shareHandler();

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 13]]);
      }));

      function shareHandler() {
        return _shareHandler.apply(this, arguments);
      }

      return shareHandler;
    }(),
    closeHandler: function closeHandler() {
      this.share.setShare(_Object$assign({}, this.shareConfig));
    },
    bgImgLoad: function bgImgLoad() {
      var _this = this;

      window.setTimeout(function () {
        _this.$refs.sharePop.showImage();
      }, 100);
    },
    filterEmoji: function filterEmoji(str, len) {
      var length = 0,
          strArr = _Array$from(str),
          // ES6的Array.from支持代理对的解析
      strArrlen = strArr.length,
          result = '';

      for (var i = 0; i < strArrlen; i++) {
        var item = strArr[i];
        length++;

        if (escape(item).length > 4) {
          // 中文或表情符编码后长度大于4，按两个字符的宽度计算
          length++;
        }

        result = result.concat(item);

        if (length >= len) {
          if (i == strArrlen - 1) {
            return result;
          }

          result = result.concat('...');
          return result;
        }
      }

      if (length < len) {
        return str;
      }
    },
    img2base64: function img2base64(url, crossOrigin) {
      return new _Promise(function (resolve) {
        var img = new Image();

        img.onload = function () {
          try {
            var c = document.createElement('canvas');
            c.width = img.naturalWidth;
            c.height = img.naturalHeight;
            var cxt = c.getContext('2d');
            cxt.drawImage(img, 0, 0); // 得到图片的base64编码数据

            resolve(c.toDataURL('image/png'));
          } catch (e) {
            window.console.error(e);
            resolve(url);
          }
        };

        img.onerror = function (e) {
          window.console.error(e);
          resolve(url);
        };

        crossOrigin && img.setAttribute('crossOrigin', crossOrigin);
        img.src = url;
      });
    }
  },
  settingKey: '分享浮层',
  setting: {}
};